import Accordion from './Classes/Accordion';
import BackToTop from './Classes/BackToTop';
import CountUpNumbers from './Classes/CountUpNumbers';
import DownloadCenter from './Classes/DownloadCenter';
import Footnotes from './Classes/Footnotes';
import LazyLoad from 'vanilla-lazyload';
import Link from './Classes/Link';
import Member from './Classes/Member';
import NavigationResponsive from './Classes/NavigationResponsive';
import Navigation from './Classes/Navigation';
import ReadingProgress from './Classes/ReadingProgress';
import SearchCounter from './Classes/SearchCounter';
import Slider from "./Classes/Slider";
import SliderHighlights from './Classes/SliderHighlights';
import Video from "./Classes/Video";
import GRI from "./Classes/Gri";
import Worldmap from "./Classes/Worldmap";
import ResponsiveTable from "./Classes/ResponsiveTable";
import Symbols from "./Classes/Symbols";
import SVGLightboxInstance from './Classes/svgLightboxInstance';
import swiper from './lib/swiper';
import LottieScrollAnimator from './Classes/LottieScrollAnimator.js';
import ChartsInPopUp from "./Classes/ChartsInPopUp";
import Anchor from "./Classes/Anchor";

let anchorInstance = null;
let chartsInPopUp = null;
let responsiveTableInstance = null;
let accordionInstance = null;
let backToTopInstance = null;
let downloadcenterInstance = null;
let footnotesInstance = null;
let lazyLoadInstance = null;
let linkInstance = null;
let memberInstance = null;
let navigationInstance = null;
let navigationReponsiveInstance = null;
let readingProgressInstance = null;
let searchCounterInstance = null;
let sliderInstance = null;
var swiperInstance = null;
let videoInstance = null;
let griInstance = null;
let symbolsInstance = null;
let svgLightboxInstance = null;
var countUpInstance = null;

export default {
  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }
};

document.addEventListener("DOMContentLoaded", function () {

  var scrollContainers = document.querySelectorAll('.three-col-container-svg, .chart-container__full-width, .full-width-chart');
  scrollContainers.forEach(function (container) {
    container.addEventListener('scroll', function () {
      this.style.overflowX = 'scroll';
    });
    if (!container.closest('.lc-columns')) {
      container.addEventListener('scroll', function () {
        this.style.overflowX = 'scroll';
      });
    }
  });


  new LottieScrollAnimator('dotlottie-player');

  chartsInPopUp = new ChartsInPopUp();

  symbolsInstance = new Symbols();

  accordionInstance = new Accordion();

  anchorInstance = new Anchor();

  backToTopInstance = new BackToTop();

  downloadcenterInstance = new DownloadCenter();

  griInstance = new GRI();

  new Worldmap();

  footnotesInstance = new Footnotes();

  lazyLoadInstance = new LazyLoad();

  linkInstance = new Link();

  memberInstance = new Member();

  navigationInstance = new Navigation();

  navigationReponsiveInstance = new NavigationResponsive();

  readingProgressInstance = new ReadingProgress();

  searchCounterInstance = new SearchCounter();

  countUpInstance = new CountUpNumbers({
    numbersSelector: '.lc-keyfigure__number',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['en-US'],
    decimalArray: ['.'],
    thousandSepArray: [','],
  });

  sliderInstance = new Slider();

  swiperInstance = new swiper('.lc-slider-highlights > .swiper', {
    slidesPerView: 3,
    centeredSlides: false,
    wrapperClass: 'swiper-wrapper',
    initialSlide: 0,
    loop: true,
    spaceBetween: 24,
    autoplay: {
      delay: 3500,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: ".lc-slider-frontpage__next",
      prevEl: ".lc-slider-frontpage__prev",
    },

    breakpoints: {
      512: {
        initialSlide: 0,
        spaceBetween: 24,
        slidesPerView: 1,
        centeredSlides: false,
      },
      798: {
        initialSlide: 0,
        spaceBetween: 24,
        slidesPerView: 2,
        centeredSlides: false,
      },
      1024: {
        initialSlide: 0,
        spaceBetween: 24,
        slidesPerView: 2,
        centeredSlides: false,
      },
      1330: {
        initialSlide: 0,
        spaceBetween: 24,
        slidesPerView: 3,
        centeredSlides: false,
      }
    },
  });

  document.querySelectorAll('.lc-slider-highlights__prev').forEach(p => {
    p.addEventListener('click', (e) => {
      swiperInstance.slidePrev();
    })
  });

  document.querySelectorAll('.lc-slider-highlights__next').forEach(p => {
    p.addEventListener('click', (e) => {
      swiperInstance.slideNext();
    })
  });



  videoInstance = new Video();

  svgLightboxInstance = new SVGLightboxInstance();

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: ".lc-table-wrap table",
    tableWrapperSelector: ".lc-table-wrap",
    breakPointLg: 3000,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 20,
    noSplitArray: [],
  });
});
